import { startCase } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { useIsMobile } from "@ryde/shared";

import { CourseStationsHeaderStyled } from "./stations.course.styled";

interface IStationsPanelHeaderCourse {
  isDragging?: boolean;
}

export const StationsPanelHeaderCourse: FC<IStationsPanelHeaderCourse> = ({
  isDragging,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useIsMobile();

  return (
    <CourseStationsHeaderStyled $isDragging={isDragging}>
      {!isMobile && <div className="column_grip_header" aria-hidden />}
      {!isMobile && <div className="column_passengers_header" aria-hidden />}
      <div className="column_map_icon_header" aria-hidden />
      <div className="column_station_info_h">
        <div className="column_station_header_spacer" aria-hidden />
        <div className="column_station_header">
          {startCase(t("station.single"))}
        </div>
        <div className="column_time_header">{startCase(t("general.TIME"))}</div>
      </div>
      {!isMobile && (
        <div className="column_area_header">{startCase(t("area.single"))}</div>
      )}
      <div className="column_duration_header">{t("general.DURATION")}</div>
      {!isMobile && <div className="column_icons_header" aria-hidden />}
    </CourseStationsHeaderStyled>
  );
};
